import { createSystem, defaultConfig } from '@chakra-ui/react';

// Use default Chakra UI v3 theme without custom modifications
const theme = createSystem(defaultConfig);

export default theme;
